import { render } from "./RelayerModal.vue?vue&type=template&id=605306cb"
import script from "./RelayerModal.vue?vue&type=script&lang=js"
export * from "./RelayerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__